import React, {useContext} from 'react';
import SettingsContext from "../../../contexts/Settings";
import  {config} from "../../../config";
import HomeSectionTitle from "../../HomeSectionTitle";
import Portfolio from "../../Portfolio";
import {Text} from "../../Text";
import "./OurWorks.scss";

const OurWorks = ({sectionTitle}) => {

	const {isMobile} = useContext(SettingsContext);

	return (
		<div className="our-works" id="our-works">
			<div className="row">
				<div className="col col-xs-12 center-xs">
					<HomeSectionTitle text={sectionTitle}/>
				</div>
			</div>
			<Portfolio isHome />
			<div className="row our-works__read-more">
				<div className="col col-xs-12 center-xs">
					<Text
						code={isMobile ? "zobacz_wiecej_naszych_prac" : "zobacz_wiecej"}
						tag="a"
						className="btn__primary"
						href={config.domainRelPath+"/our-works"}
						title="Link: Portfolio"
						target="_top"
					/>
				</div>
			</div>
		</div>
	);
};

export default OurWorks;